module.exports = __webpack_public_path__ + "static/img/ki.a02a4304.svg";